import { put, call, select } from 'redux-saga/effects';
import * as actions from '../actions/index';
// import * as analyticsActions from '../actions/analyticsActions';
import GZHAuth from '../vendors/GZHAuth';
import { getUserData, LOG, RavenIdentify } from '../helpers/utils';

export function* loginNossaUser(action) {
  LOG('login nossa', action);
  yield put(actions.fetchingUser(true));
  const {
    user: {
      authentication: { stsTokenManager: { accessToken }, loginType, uid },
      userInfo: { email },
    },
  } = action;

  const extraData = { loginType, methodLogin: loginType, methodLoginId: uid || '' };
  const user = {
    ...action.user.userInfo,
    isSubscriber: action.user.userInfo.subscriber,
    personType: action.user.userInfo.personType === 'J' ? 'Jurídica' : 'Física',
  };

  LOG('login nossa', uid);

  yield put(actions.receiveUserNossa(user, accessToken, uid, false));

  const metrics = yield select(state => state.MetricsReducer.metrics);
  const { displayName } = action.user.authentication;
  const { subscriber, employee } = action.user.userInfo;
  const props = {
    ...metrics,
    nome: displayName,
    email,
    loginType,
    digitalId: subscriber ? 'assinante' : (employee ? 'funcionario' : 'nao assinante'),
    ...extraData
  };

  yield put(actions.setProperties(props));
  yield put(actions.fetchingUser(false));

  LOG('Saga', 'loginNossaUser', action);
}

export function* receiveToken(response) {
  LOG('UserReducer', 'receiveToken', response);
  yield put(actions.fetchingUser(true));
  const gzhAuth = new GZHAuth();
  const user = yield call(() => gzhAuth.getUserInfo(response.token, response.data));
  const receivedToken = yield select(state => state.UserReducer.receivedToken);
  yield put(actions.fetchingUser(false));
  yield put(actions.receiveUser(user, receivedToken, response));
  LOG('UserReducer', 'user', user);
}

export function* isAuthenticated() {
  const gzhAuth = new GZHAuth();
  if (gzhAuth.isAuthenticated()) {
    const loginRevalidatedResponse = yield call(() => gzhAuth.revalidateLogin(gzhAuth.getToken()));
    if (loginRevalidatedResponse && loginRevalidatedResponse.token !== undefined) {
      LOG('UserSaga', 'isAuthenticated', loginRevalidatedResponse);
      const origin = yield select(state => state.UserReducer.origin);
      const loginType = yield select(state => state.UserReducer.loginType);
      yield put(actions.receiveToken(loginRevalidatedResponse.token, { _links: loginRevalidatedResponse._links }, origin, loginType, false));
      LOG('UserSaga', 'isAuthenticated', 'receiveToken_____', loginRevalidatedResponse.token);
    } else {
      const user = yield call(() => gzhAuth.getUserInfo(gzhAuth.getToken()));
      yield put(actions.receiveUser(user, false));
    }
  } else {
    yield put(actions.setMetricsReady(true));
  }
  yield put(actions.fetchingUserAuthentication(false));
}

export function* logoutUser() {
  window.isLoggedNossa = false;
  yield put(actions.showCloseIframe());
  yield put(actions.logoutUserAction());

  window.nossaContainer.logOut(true);

  yield put(actions.resetUserMetrics());
  yield put(actions.sendCustomEvent('realizou logout', getUserData({}), true));
  RavenIdentify({});
}

export function* receiveUser(action) {
  const metrics = yield select(state => state.MetricsReducer.metrics);
  const extraData = action.data.data && action.data.data.methodLogin
    ? { methodLogin: action.data.data.methodLogin, methodLoginId: action.data.data.methodLoginId }
    : '';

  const props = { ...metrics, ...getUserData(action.user), ...extraData };
  yield put(actions.setProperties(props));
  // @todo: Reset User.
  yield put(actions.setMetricsReady(true));

  RavenIdentify({ email: action.user.email, id: action.user.username });
  if ('origin' in action.data && action.data.origin) { // just logged in
    yield put(actions.sendKMIdentify(props));
    yield put(actions.sendKMSet(props));
    yield put(actions.sendCustomEvent('realizou login'));
  }
}

export function* receiveUserNossa(action) {
  yield put(actions.setProperties({}));
  // @todo: Reset User.
  yield put(actions.setMetricsReady(true));

  RavenIdentify({ email: action.user.email, id: action.user.username });
}
